module.exports = __webpack_public_path__ + "img/img-area-operacoes-banner.b2dfd829.png";